import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appSelectOnFocus]',
    standalone: false
})
export class SelectTextOnFocusDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('focus') onFocus() {
    this.elementRef.nativeElement.select();
  }
}
